export function formatCappedCount(value: number, cap = 99): string {
  return value > cap ? `${cap}+` : String(value)
}
